// extracted by mini-css-extract-plugin
export default {"messages":"Messages_messages__p511C","empty":"Messages_empty__KPtla"};